<template>
	<div id="dashboardMenu">
    	<Loading v-if="loading" :text="'Atualizando'"></Loading>
		<div class="top-bar container-fluid bg-white px-4">
			<div class="row py-3 align-items-center justify-content-between shadow-xl mx--4">
				<div class="col-4 text-left">
					<ul class="ul d-flex align-items-center">
						<li>
							<div>
								<div class="menu-aniation" v-if="menuAnimation">
									<span class="icon-menu position-absolute bg-primary ball-animation-menu"></span>
									<span class="icon-menu position-absolute bg-primary ball-animation-menu-small"></span>
								</div>
								<span class="icon-menu p-3 cursor-pointer" @click="handleMenu">
									<i class="fal fa-bars font-24"></i>
								</span>
							</div>
						</li>
						<div class="menu-content-text ml-4" v-if="checkSiteActive">
							<router-link to="/dashboard">
								<span class="menu-paginas btn btn-white d-none d-md-inline px-1 px-md-2 py-2">
									<strong>Início</strong>
								</span>
							</router-link>
							<span
								class="menu-paginas btn btn-white d-none d-md-inline px-1 px-lg-4 py-2"
								@click="toggleMenu(); goMenuOption(6);"
							>
								<strong>Páginas</strong>
							</span>
						</div>
					</ul>
					<div
						v-show="getIsOpenMenu"
						class="menu-content"
						:class="[menuOption == 4 ? '' : 'menu-overflow']"
					>
						<div class="overlay-menu" @click="toggleMenu()"></div>

						<div class="menu-option" v-if="getActiveOption === 1">
							<div class="navigation-menu px-4 py-3">
								<div class="row no-gutters justify-content-between">
									<div class="col text-left">
										<span v-if="getActiveOption != 1">
											<i @click="backMenu()" class="fal fa-chevron-left step-button"></i>
										</span>
										<span class="icon-menu close-menu" v-else @click="toggleMenu()">
											<i class="fal fa-times"></i>
										</span>
									</div>
									<div class="col text-right">
										<span class="icon-menu" v-if="getActiveOption != 1" @click="saveData = true">
											<b class="color-theme">OK</b>
										</span>
									</div>
								</div>
							</div>
						<div class="text-left">
							<ul class="menu-list" v-if="checkSiteActive">
								<li @click="goCheckout" v-if="checkContract">
									<i class="fal fa-key mr-3 color-theme"></i>
									<span class="font-title">Ativação</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li class="d-block d-md-none" @click="toggleMenu()">
									<router-link to="/dashboard">
										<i class="fal fa-home mr-3 color-theme"></i>
										<span class="font-title">Início</span>
									</router-link>
								</li>
								<li @click="goLinkSeo()">
										<i class="fal fa-user-edit mr-3 color-theme"></i>
										<span class="font-title">Dados do site (SEO)</span>
										<span class="float-right">
										<i class="fal fa-chevron-right"></i>
										</span>
								</li>
								<li @click="goMenuOption(2)">
									<i class="fal fa-phone mr-3 color-theme"></i>
									<span class="font-title">Dados de contato</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goMenuOption(9)">
									<i class="fal fa-flag mr-3 color-theme"></i>
									<span class="font-title">Logo</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<!-- <li @click="goMenuOption(3)">
								<i class="fal fa-bookmark mr-3 color-theme"></i>
								<span class="font-title"> Notificações </span>
								<span class="float-right">
									<i class="fal fa-chevron-right"></i>
								</span>
								</li>-->
								<li @click="goMenuOption(4)">
									<i class="fal fa-clock mr-3 color-theme"></i>
									<span class="font-title">Integrações</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goMenuOption(5)">
									<i class="fal fa-inbox mr-3 color-theme"></i>
									<span class="font-title">Oportunidades</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goLinkBuild()">
									<i class="fal fa-tree mr-3 color-theme"></i>
									<span class="font-title">Link Building</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goDesign">
									<i class="fal fa-palette mr-3 color-theme"></i>
									<span class="font-title">Design</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goMenuOption(6)">
									<i class="fal fa-layer-group mr-3 color-theme"></i>
									<span class="font-title">Páginas</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goBannersSelos()">
									<i class="fal fa-ad mr-3 color-theme"></i>
									<span class="font-title">Banners e Selos</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goMenuOption(8)">
									<i class="fal fa-globe-americas mr-3 color-theme"></i>
									<span class="font-title">Domínios</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goRedirects()">
										<i class="fal fa-link mr-3 color-theme"></i>
									<span class="font-title">Redirecionamentos</span>
									<span class="float-right">
									<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goFiles()">
									<i class="far fa-file-alt mr-3 color-theme"></i>
									<span class="font-title">Arquivos</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li v-if="affiliate == 1" @click="goMenuOption(11)">
									<i class="fal fa-dollar-sign mr-3 color-theme"></i>
									<span class="font-title">Afiliados</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<!-- <li @click="goMenuOption(12)">
								<i class="fal fa-barcode mr-3 color-theme"></i>
								<span class="font-title"> Código promocional </span>
								<span class="float-right">
									<i class="fal fa-chevron-right"></i>
								</span>
								</li>-->
								<li v-if="financial()" @click="goMenuOption(14)">
									<i class="fal fa-file-contract mr-3 color-theme"></i>
									<span class="font-title">Minhas assinaturas</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="goMenuOption(10)">
									<i class="fal fa-life-ring mr-3 color-theme"></i>
									<span class="font-title">Ajuda</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
									<li @click="logout()">
									<i class="fal fa-sign-out-alt fa-flip-horizontal mr-3 color-theme"></i>
									<span class="font-title">Sair</span>
								</li>
							</ul>
							<ul class="menu-list" v-else>
								<li @click="goMenuOption(14)">
									<i class="fal fa-file-contract mr-3 color-theme"></i>
									<span class="font-title">Minhas assinaturas</span>
									<span class="float-right">
										<i class="fal fa-chevron-right"></i>
									</span>
								</li>
								<li @click="logout()">
									<i class="fal fa-sign-out-alt fa-flip-horizontal mr-3 color-theme"></i>
									<span class="font-title">Sair</span>
								</li>
							</ul>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 2">
						<div class="navigation-menu px-4 py-3">
							<div class="row no-gutters justify-content-between">
								<div class="col text-left">
									<span>
										<i
										v-if="getActiveOption != 1"
										@click="backMenu()"
										class="fal fa-chevron-left step-button"
										></i>
									</span>
								</div>
								<div class="col text-right">
									<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
										<i class="fas fa-bars"></i>
									</span>
									<span class="icon-menu" v-else @click="saveData = true">
										<b class="color-theme">OK</b>
									</span>
								</div>
							</div>
						</div>
						<div class="row text-left justify-content-center">
							<div class="col-12">
								<div class="px-4 py-3">
								<perfilComponent
									:siteId="siteId"
									:saveData="saveData"
									@updateMenuOption="backMenu"
									@resetSaveData="saveData = false"
								></perfilComponent>
								</div>
							</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 3">
						<div class="navigation-menu px-4 py-3">
							<div class="row no-gutters justify-content-between">
								<div class="col text-left">
									<span>
										<i
										v-if="getActiveOption != 1"
										@click="backMenu()"
										class="fal fa-chevron-left step-button"
										></i>
									</span>
								</div>
								<div class="col text-right">
									<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
										<i class="fas fa-bars"></i>
									</span>
									<span class="icon-menu" v-else @click="saveData = true">
										<b class="color-theme">OK</b>
									</span>
								</div>
							</div>
						</div>
						<div class="row text-left justify-content-center">
							<div class="col-12">
								<div class="px-4 py-3">
									<notificacoesComponent
										:notifies="10"
										:siteId="siteId"
										:saveData="saveData"
										@updateMenuOption="backMenu"
									></notificacoesComponent>
								</div>
							</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 4">
						<div class="navigation-menu px-4 py-3">
							<div class="row no-gutters justify-content-between">
								<div class="col text-left">
									<span>
										<i
										v-if="getActiveOption != 1"
										@click="backMenu()"
										class="fal fa-chevron-left step-button"
										></i>
									</span>
								</div>
								<div class="col text-right">
									<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
										<i class="fas fa-bars"></i>
									</span>
									<span class="icon-menu" v-else @click="backMenu">
										<b class="color-theme">OK</b>
									</span>
								</div>
							</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<integracoesComponent :siteId="siteId" :saveData="saveData"></integracoesComponent>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 5">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<messagelist :siteId="siteId"></messagelist>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 6">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<sessoesComponent
								:siteId="siteId"
								:saveData="saveData"
								@updateMenuOption="backMenu"
								@updateActiveCategory="updateActiveCategory"
								@updateDashboardActiveCategory="
								updateDashboardActiveCategory
								"
							></sessoesComponent>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 7">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							<span class="icon-menu" v-else @click="saveData = true">
								<b class="color-theme">OK</b>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<whatsAppComponent
								:siteId="siteId"
								:saveData="saveData"
								@updateMenuOption="backMenu"
								:whatsappIdd="whatsappIdd"
							></whatsAppComponent>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 8">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<domainsList
								:siteId="siteId"
								:saveData="saveData"
								@updateMenuOption="backMenu"
								@updateDomain="updateDomain($event)"
							/>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 9">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<logoManagement :siteId="siteId" :saveData="saveData" @back="$event == true ? backMenu() : false"/>
							<!-- <hr class="my-5 mx--4" />
							<faviconManagement :siteId="this.siteId" :saveData="saveData" /> -->
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 10">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<div class="mb-4">
								<h4>Precisa de ajuda?</h4>
							</div>
							<p>Entre em contato com a gente!</p>
							<p class="mb-0">
								<strong>
								<i class="fal mr-3 fa-envelope"></i> {{contactEmail}}
								</strong>
							</p>
							<p>
								<i class="fal mr-3 fa-phone"></i> +55
								<strong>{{contactTel}}</strong>
							</p>
							<p>
								Nosso atendimento funciona de Segunda à Sexta das
								<strong>08:00</strong> às
								<strong>17:00</strong>
							</p>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 11">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<affiliateList />
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 12">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<PromotionalCode :saveData="saveData" @updateMenuOption="backMenu" />
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 13">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
							<div class="col text-right">
							<span class="icon-menu" v-if="getActiveOption == 1" @click="toggleMenu()">
								<i class="fas fa-bars"></i>
							</span>
							<span class="icon-menu" v-else @click="saveData = true">
								<b class="color-theme">Aplicar</b>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<h4 class="mb-4">Template</h4>
							<templates
								:currentTemplate="$store.state.siteActive.template"
								:source="'dashboard'"
								:saveData="saveData"
								@updateMenuOption="backMenu"
							/>
							</div>
						</div>
						</div>
					</div>

					<div class="menu-option" v-else-if="getActiveOption === 14">
						<div class="navigation-menu px-4 py-3">
						<div class="row no-gutters justify-content-between">
							<div class="col text-left">
							<span>
								<i
								v-if="getActiveOption != 1"
								@click="backMenu()"
								class="fal fa-chevron-left step-button"
								></i>
							</span>
							</div>
						</div>
						</div>
						<div class="row text-left justify-content-center">
						<div class="col-12">
							<div class="px-4 py-3">
							<h4 class="mb-4">Minhas assinaturas</h4>
							<Signatures />
							</div>
						</div>
						</div>
					</div>
					</div>
				</div>

				<div class="col-4 text-center px-0" style="font-weight: 700">
					<div class="logo-uli">
						<img :src="brandImage()" class="img-fluid pointer" @click="goDashboard()"/>
					</div>
				</div>

				<div class="col-4 text-right">
					<a
					:href="handleLink"
					id="domainSite"
					class="btn btn-white py-2 px-3"
					target="_blank"
					v-if="handleLink"
					>
					<span class="d-none d-md-block">
						<strong>Ver site</strong>
					</span>
					<span class="d-md-none">
						<i class="fal fa-external-link-alt"></i>
					</span>
					</a>

					<span v-else>
					<i class="fas fa-spinner fa-spin btn-white"></i>
					</span>

					<img
					@click="toggleUserPanel = !toggleUserPanel"
					class="ml-1 ml-md-4 rounded-circle pointer menu-avatar-image"
					:src="userAvatar"
					/>

					<div v-if="toggleUserPanel" class="menu-user-panel">
					<div class="row">
						<div class="col-12">
						<div class="total-avatar text-center">
							<img class="rounded" :src="userAvatar" alt />
							<button class="avatar-button" onclick="document.getElementById('file').click()">
							<i class="fas fa-image"></i>
							</button>
							<p class="txt-name">{{ userName }}</p>
							<input
							type="file"
							accept=".jpeg, .png, .jpg, .gif"
							id="file"
							ref="file"
							@change="handleFileUpload()"
							style="display: none"
							/>
						</div>
						<hr />
						</div>
						<div class="col-12">
						<a class="m-0 pointer" href="#" @click="goToUserDashboard()">Perfil</a>
						</div>
						<div class="col-12">
						<hr />
						<p @click="logout" class="m-0 pointer">Sair</p>
						</div>
					</div>
					</div>
					<!-- <div class="box-1 box-xl-2 overflow-hidden rounded-circle position-relative d-inline-block" data-toggle="dropdown">
					<img class="img-fluid position-absolute ps-center" :src="userAvatar" />
					</div>-->
				</div>
			</div>
		</div>
		<template v-if="pendingBill > 0">
			<dashboard-alert-bar :alertType="'danger'" >
				<p class="message-text" slot="message"> Atenção: Existem faturas em aberto <button class="mt-2 mt-md-0 btn btn-primario" @click.prevent="goCheckoutBanner()" :siteID="siteId">Ver faturas</button> </p>
			</dashboard-alert-bar>
		</template>
		<template v-else-if="!domainStatus">
			<dashboard-alert-bar :alertType="'danger'" >
				<div slot="message">
					<p class="message-text" > Atenção: Seu site está fora do ar!</p>
					<p >Detectamos problemas com seu domínio. Verificar com operadora.</p>
				</div>
			</dashboard-alert-bar>
		</template>
	</div>
</template>

<script>
import axios from "axios";
import perfilComponent from "./PerfilComponent";
import notificacoesComponent from "./NotificacoesComponent";
import integracoesComponent from "./IntegracoesComponent";
import templates from "./Templates";
import sessoesComponent from "./SessoesComponent";
import domainsList from "./organisms/DomainsList";
import messagelist from "./organisms/MessageList";
import logoManagement from "./organisms/LogoManagement";
import faviconManagement from "./organisms/FaviconManagement";
import affiliateList from "./organisms/AffiliateList";
import whatsAppComponent from "./WhatsAppComponent";
import Signatures from "./organisms/Signatures";
import Loading from "./Loading";
import PromotionalCode from "./organisms/PromotionalCode";
import DashboardAlertBar from '@/components/molecules/DashboardAlertBar'
import {mapState} from "vuex";
import { mapGetters } from "vuex";

// import selectLogo from "./organisms/selectLogo";
import apiMixins from "@/mixins/apiMixins";

export default {
  mixins: [apiMixins],
  name: "dashboardMenu",
  data() {
    return {
		menuAnimation: 1,
		toggleUserPanel: false,
		userName: "",
		userAvatar: "/static/img/default-user.png",
		userTemplate: null,
		menuOption: 1,
		saveData: false,
		siteId: null,
		mainDomain: "",
		whatsappIndex: null,
		whatsappIdd: "",
		whatsappNumber: "",
		contactPhone: "",
		loading: false,
		ROOT_API: null,
		CDN_URL: null,
      	affiliate: 0,
		pendingBill: 0,
		domainStatus: true
    };
  },
  props: {
    route: {
      type: String,
      required: false,
    },
  },
  methods: {
	updateActiveCategory(categoryId, categoryRoute) {
		this.$emit("updateActiveCategory", categoryId, categoryRoute);

		this.handleMenu();
	},
	async goToUserDashboard() {
		if(localStorage.panelUrl){
			window.location.href = localStorage.panelUrl;
		}
      // const urlDashboardUser = this.$session.get("urlDashboardUser");
      // if (!urlDashboardUser) {
      //   const userDashboardData = await this.requestApiData(
      //     "/user/panel",
      //     "get"
      //   );
      //   this.$session.set("urlDashboardUser", userDashboardData.data.url);
      //   window.location.href = userDashboardData.data.url;
      // } else {
      //   window.location.href = urlDashboardUser;
      // }
	},
	financial(){
		return window.localStorage.getItem('financial') == '1';
	},
	goLinkBuild(){
		this.toggleMenu();
		this.$router.push("/dashboard/linkBuilding");
	},
	goBannersSelos(){
		this.toggleMenu();
		this.$router.push("/dashboard/publicidades");
	},
	goRedirects(){
		this.toggleMenu();
		this.$router.push("/dashboard/redirects");
	},
	goFiles(){
		this.toggleMenu();
		this.$router.push("/dashboard/files");
	},
	goLinkSeo(){
		this.toggleMenu();
		this.$router.push("/dashboard/seo");
	},
	toggleMenu(){
		this.$store.dispatch("dashboardModule/TOGGLE_MENU");
	},
    handleMenu() {
      	this.$session.set("animationMenu", 0);
      	this.menuAnimation = 0;
      	this.toggleUserPanel = false;
		this.$store.dispatch("dashboardModule/TOGGLE_MENU");
    },
    goCheckoutBanner(){
      	this.handleMenu();
      	this.goMenuOption(14);
	},
	goDashboard() {
		if (this.$route.path !== "/dashboard") {
			this.$store.state.siteActive.status ? this.$router.push("/dashboard")
			: this.$router.push("/dashboard/payment_alert");
		} else {
			this.$router.go();
		}
	},
    verifyPendingBill(){
      let token = this.$session.get("jwt");
			this.siteId = this.$session.get("siteId")
      axios({
        method: "get",
        url: `${process.env.ROOT_API}/api/site/${this.siteId}/bill?status=waiting`,
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/x-www-form-urlencoded",
        },
      })
      .then((response) => {
          if (response.data.status == 1) {
            this.pendingBill = response.data.bill.length;
          }
          return true;
      })
        .catch((response) => {
          return false;
        });
    },
    backMenu() {
		this.goMenuOption(1);
     	this.saveData = false;
    },
    async goMenuOption(index) {
		if (index == 5 && this.$store.state.application.id == 5) {
			let opportunities = await this.requestApiData("/opportunities/login", "get");
			if (opportunities.message.url) {
				window.location.href = opportunities.message.url;
			} else {
				alert("Erro ao acessar o painel de oportunidades. Por favor, entre em contato com o atendimento");
			}
		} else {
			this.$store.dispatch("dashboardModule/UPDATE_MENU_OPTION", [index]);
		}
    },
    brandImage() {
      return this.$store.state.application.app_logo;

      let url = window.location.hostname;
      if (url === "painel.sitejet.com.br") {
        return "https://sitejet.com.br/img/Logo-Sitejet.png";
      } else {
        return "https://ulisite.com/img/logo-uli.svg";
      }
    },
    updateDashboardActiveCategory() {
      this.$emit("updateCategories");
    },
    handleFileUpload() {
      let str = this.$refs.file.files[0].name.toLowerCase().split(".");
      let ext = str[str.length - 1];
      if (ext == "jpeg" || ext == "jpg" || ext == "png" || ext == "gif") {
        this.file = this.$refs.file.files[0];
        this.submitFile();
      } else {
        alert(
          "Arquivo " +
            this.$refs.file.files[0].name +
            " não suportado. Selecione novamente"
        );
      }
    },
    updateStatus,
    submitFile,
    loadDataSite,
    logout,
    getDomain,
    updateDomain,
    goDesign,
    goCheckout
  },
  computed: {
	...mapGetters("dashboardModule", [
		"getIsOpenMenu",
		"getActiveOption",
	]),
  ...mapState({
    contactEmail: state => state.contact.email,
    contactTel: state => state.contact.tel,
  }),
    checkContract() {
      if (window.localStorage.getItem("statusContract") !== "active") {
        return false; //ALTERAR
      } else {
        return false;
      }
	},
	checkSiteActive(){
		return this.$store.state.siteActive.status
	},
    handleLink() {
      if (this.mainDomain) {
		this.$store.dispatch("dashboardModule/setSiteLink", [`https://${this.mainDomain}`]);
        if (this.route) {
          return `https://${this.mainDomain}${this.route}`;
        } else {
          return `https://${this.mainDomain}`;
        }
      } else {
        return false;
      }
    },
  },
  components: {
    perfilComponent,
    notificacoesComponent,
    integracoesComponent,
    templates,
    sessoesComponent,
    domainsList,
    messagelist,
    whatsAppComponent,
    Loading,
    logoManagement,
    faviconManagement,
    affiliateList,
    PromotionalCode,
	Signatures,
	DashboardAlertBar,
  },
  created() {
    this.ROOT_API = process.env.ROOT_API;
    this.CDN_URL = process.env.CDN_URL;
		this.verifyPendingBill();
  },
  mounted() {
    this.loadDataSite();
    this.affiliate = localStorage.getItem("showAffiliate");
    this.menuAnimation = this.$session.get("animationMenu");
		this.siteId = this.$session.get("siteId");

  },
  watch: {
    menuOption() {
      if (this.menuOption == 1) {
        this.updateStatus();
        this.$emit("updateCategories");
      }
    },
  },
};
function goDesign() {
	this.loading = true;
  	let token = this.$session.get("jwt");
  	axios({
    	method: "get",
    	url: this.ROOT_API + "/api/site/" + this.siteId + "/design/access",
    	headers: {
      		Authorization: "Bearer " + token,
      		"Content-Type": "application/x-www-form-urlencoded",
    	},
	 }).then((response) => {
	    if (response.data.status == 1) {
	      window.location.replace(response.data.url + "&urlGet=" + window.location.host);
	    } else {
	    	this.loading = false;
	      	alert("Erro ao abrir painel de design.");
	    }
	});
}
function goCheckout() {
  this.$router.push("/dashboard/checkout");
}
function updateDomain(event) {
  this.getDomain();
}
function getDomain() {
  let token = this.$session.get("jwt");
  axios({
    method: "get",
    url: this.ROOT_API + "/api/site/" + this.siteId + "/domain",
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  }).then( (response) => {
    let domains = response.data.data
    //Busca o domínio marcado como domínio principal
    let domainActive = domains.filter((domain) => {
      return domain.main_domain == 1;
    });

    //Se não houver domínio configurado como domínio principal, busca o criado automáticamente
    if ( !domainActive ) {
      domainActive = domains.filter((domain) => {
        return domain.automatic == 1;
      });

      //setSessionDomain(domainActive[0]);
      this.mainDomain = domainActive[0].domain;
      this.$session.set("domain", "https://" + this.mainDomain);
    }
    //Senão, valida se o domínio principal está online
    else if( domainActive[0].automatic != 1 ){
      axios({
        method: "get",
          url: this.ROOT_API + "api/site/" + this.siteId + "/domain/" + domainActive[0].id + "/dns",
          headers: {
            Authorization: "Bearer " + token,
          },
      })
      .then( (response) => {
        if (response.data.data !== 'online'){
			this.domainStatus = false;
          	domainActive = domains.filter((domain) => {
            	return domain.automatic == 1;
          	});
        }

        //setSessionDomain(domainActive[0]);
        this.mainDomain = domainActive[0].domain;
        this.$session.set("domain", "https://" + this.mainDomain);
      });
    }
    else{
      //setSessionDomain(domainActive[0]);
      this.mainDomain = domainActive[0].domain;
      this.$session.set("domain", "https://" + this.mainDomain);
    }

  });

}
function updateStatus() {
  let totalData = "";
  let token = this.$session.get("jwt");
  axios({
    method: "get",
    url: this.ROOT_API + "/api/site/" + this.siteId,
    data: totalData,
    headers: {
      Authorization: "Bearer " + token,
      "Content-Type": "application/x-www-form-urlencoded",
    },
  })
    .then((response) => {
      this.userName = response.data.name;
      this.userTemplate = response.data.template;
      this.whatsappIndex = response.data.whatsappIndex;
      this.whatsappIdd = response.data.whatsappIdd;
      this.whatsappNumber = response.data.whatsappNumber;
      if (response.data.image != null) {
        this.userAvatar = this.CDN_URL + response.data.image;
      }
	  this.$emit('avatar',this.userAvatar);
    })
    .catch(function () {
      console.log("Falha ao atualizar dados de perfil");
    })
    .finally(() => {
      this.getDomain();
      this.loading = false;
    });
}
function submitFile() {
  this.loading = true;
  let formData = new FormData();
  let token = this.$session.get("jwt");
  formData.append("image", this.file);
  axios({
    method: "post",
    url: this.ROOT_API + "/api/site/" + this.siteId + "/avatar/update",
    data: formData,
    headers: {
      Authorization: "Bearer " + token,
      // 'Content-Type': 'application/x-www-form-urlencoded'
    },
  })
    .then((response) => {
      this.updateStatus();
    })
    .catch(function () {
      console.log("Falha ao atualizar foto de perfil");
    });
}
function loadDataSite() {
  let totalData = "";
  let token = this.$session.get("jwt");
  axios({
    method: "get",
    url: this.ROOT_API + "api/site/" + this.siteId,
    data: totalData,
    headers: {
      Authorization: "Bearer " + token,
      // 'Content-Type': 'application/x-www-form-urlencoded'
    },
  })
    .then((response) => {
      this.userName = response.data.name;
      this.userTemplate = response.data.template;
      this.whatsappIndex = response.data.whatsappIndex;
      if (response.data.whatsappIdd) {
        this.whatsappIdd = response.data.whatsappIdd;
      }
      this.whatsappNumber = response.data.whatsappNumber;
      this.contactPhone = response.data.contactPhone;
      if (response.data.image != null) {
        this.userAvatar = this.CDN_URL + response.data.image;
      }
	  this.$emit('avatar',this.userAvatar);
    })
    .catch(function (response) {
      console.log("Erro ao recuperar dados do site");
    })
    .finally(() => {
      this.getDomain();
    });
}
function logout() {
  let token = this.$session.get("jwt");
  axios({
    method: "get",
    url: `${this.ROOT_API}api/site/${this.siteId}/post/imported/update`,
    data: "",
    headers: {
      Authorization: "Bearer " + token,
      // 'Content-Type': 'application/x-www-form-urlencoded'
    },
  });
  let urlLogout = this.$store.state.application.callback_url;
  this.$session.destroy();
  localStorage.clear();
  if (urlLogout) {
    if (urlLogout.includes('epics.vc')) {
      window.location.replace("https://epics.com.br/dashboard")
    }
    window.location.replace("https://" + urlLogout);
  } else {
    this.$router.push("/login");
  }
}
</script>
<style scoped>
a {
  color: #111;
}
a:hover {
  text-decoration: none;
}
.menu-user-panel {
  text-align: left;
  position: fixed;
  right: 15px;
  top: 75px;
  width: 290px;
  background-color: #fff;
  padding: 15px;
  box-shadow: 1px 9px 20px 4px #ccc;
  border-radius: 8px;
  z-index: 30;
}
.menu-user-panel a {
  color: #111;
}
.menu-user-panel a:hover {
  text-decoration: none;
}
.menu-avatar-image {
  width: 50px;
  height: 50px;
  object-fit: cover;
}
.logo-uli img {
  max-height: 45px;
}
#domainSite {
  color: var(--main-color);
}
#domainSite:hover {
  text-decoration: none;
}
.nav-tabs {
  padding-bottom: 20px;
}
.menu-content {
  display: inline-block;
  width: 375px;
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 11;
  background-color: rgb(255, 255, 255);
}
.andBtn {
  background-color: fade(var(--main-color), 60%);
}
.ball-animation-menu {
  width: 50px;
  height: 50px;
  opacity: 0.2;
  border-radius: 50%;
  left: 41px;
  top: 10px;
  animation: ballMenuBig 2s infinite;
  z-index: 0 !important;
}
@keyframes ballMenuBig {
  to {
    transform: scale(1.3);
    opacity: 0;
  }
  from {
    transform: scale(0.3);
  }
}
.ball-animation-menu-small {
  width: 30px;
  height: 30px;
  opacity: 0.3;
  border-radius: 50%;
  left: 51px;
  top: 20px;
  animation: ballMenuSmall 2s infinite;
  z-index: 0 !important;
}
@keyframes ballMenuSmall {
  to {
    transform: scale(1.3);
    opacity: 0;
  }
  from {
    transform: scale(0.3);
  }
}
.overlay-menu {
  top: 0;
  left: 0;
  z-index: 98;
  width: 100%;
  height: 100%;
  position: fixed;
  background: #2b2931ab;
}
.menu-overflow {
  overflow-y: auto;
  overflow-x: hidden;
}
.menu-option {
  z-index: 99;
  background: #fff;
  min-height: 100vh;
  position: relative;
}
@media all and (max-width: 500px) {
  .menu-avatar-image {
    width: 24px;
    height: 24px;
  }
  .menu-content {
    width: 100%;
  }
  .logo-uli img {
    max-height: 24px;
  }
}
@media all and (min-width: 992px) {
}
.menu {
  width: 100%;
  padding-top: 5px;
}
.txt-name {
  color: black;
  font-size: 16px;
  font-weight: 700;
  margin-top: 20px;
}
.txt-site {
  color: gray;
  font-size: 0.6em;
}
.menu-list {
  padding-left: 0;
  margin-bottom: 0;
}
.menu-list li {
  list-style-type: none;
  color: black;
  padding: 20px 0;
  border-top: 1px solid;
  border-color: #d4d4d44d;
  transition: all 100ms;
  min-height: 47px;
  padding-left: 30px;
  font-size: 16px;
}
.menu-list li:hover {
  cursor: pointer;
}
.menu-list i {
  font-size: 16px;
}
.menu-list .fa-chevron-right {
  color: #333333 !important;
  margin-right: 30px;
}
.navigation-menu {
  color: var(--main-color);
}

.navigation-menu span:hover {
  cursor: pointer;
}
.close-menu {
  font-size: 1.2rem;
}
.add-item-seo {
  border-radius: 50px;
  padding: 3px 6px;
  background-color: var(--main-color);
  margin: 5px 2px 5px 0;
  display: inline-block;
  color: white;
  font-size: 0.7em;
}

.dashboard-component label {
  font-family: "Open Sans", sans-serif;
  font-size: 10px;
  font-weight: 700;
}

.total-avatar {
  padding: 7px 0;
}
.total-avatar p {
  margin-bottom: 3px;
}
.total-avatar img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.avatar-button {
  background-color: var(--main-color);
  color: white;
  border: none;
  border-radius: 50px;
  padding: 8px 12px;
  margin-left: -28px;
  position: relative;
  bottom: -46px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardMenu.vue